import {Grid} from '@material-ui/core'
function NaoEncontrada() {
    return (
        <Grid
        style={{
            height: '70vh',
            textAlign: 'center',
            fontSize: '1.6em'
        }}>
            <h2>Ops!</h2>
            <p>a pagina pesquisada não foi encontrada!</p>
        </Grid>
    )
}

export default NaoEncontrada;
